import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createApiClient, AuthProvider } from '@deckspace/client';
import { ApiProvider } from './lib/api-context';
import { bootstrapRenderers } from './catalog-bootstrap';
import App from './App';
import './styles/globals.css';

// Register every catalog renderer against the @deckspace/ui registry.
// Data-backed types are wrapped with `withDataset` so SurfaceRenderer
// dispatches uniformly — the HOC handles fetch/loading/error.
bootstrapRenderers();

const apiUrl = import.meta.env.VITE_API_URL;
if (!apiUrl) {
  throw new Error('Missing VITE_API_URL environment variable.');
}

const api = createApiClient(apiUrl);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiProvider value={api}>
        <AuthProvider api={api}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </ApiProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>
);
